import angular from 'angular';
import moment from 'moment';

(function() {
    'use strict';
    angular.module('app.core').factory('PreInvoicesFilter', PreInvoicesFilterData);

    PreInvoicesFilterData.$inject = ['KISS_INVOICE'];

    /* @ngInject */
    function PreInvoicesFilterData(KISS_INVOICE) {
        PreInvoicesFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch,
            setPage: setPage,
            setPageSize: setPageSize,
            setSort: setSort,
            resetSort: resetSort
        };

        function PreInvoicesFilter(preInvoicesFilterData) {
            if (!preInvoicesFilterData) {
                this.buildEmpty();
            } else {
                this.build(preInvoicesFilterData);
            }
        }

        return PreInvoicesFilter;

        /////////////////////

        function buildEmpty() {
            this.sellerId = null;
            this.buyerId = null;
            this.transmissionMode = 'all';
            this.functionalStatus = 'all';
            this.creationMinDate = null;
            this.creationMaxDate = null;
            this.updateMinDate = null;
            this.updateMaxDate = null;
            this.pcpId= null;
            this.refDoc = null;
            this.pageCriteria = {
                pageSize: KISS_INVOICE.pagination.defaultPageSize,
                page: KISS_INVOICE.pagination.defaultPage,
                sorts: KISS_INVOICE.pagination.defaultSort
            };
        }

        function build(preInvoicesFilterData) {
            this.sellerId = preInvoicesFilterData.sellerId || null;
            this.buyerId = preInvoicesFilterData.buyerId || null;
            this.pcpId = preInvoicesFilterData.pcpId || null;
            this.transmissionMode = preInvoicesFilterData.transmissionMode || 'all';
            this.functionalStatus = preInvoicesFilterData.functionalStatus || 'all';
            this.creationMinDate = _extractDateWithoutTime(preInvoicesFilterData.creationMinDate);
            this.creationMaxDate = _extractDateWithoutTime(preInvoicesFilterData.creationMaxDate);
            this.updateMinDate = _extractDateWithoutTime(preInvoicesFilterData.updateMinDate);
            this.updateMaxDate = _extractDateWithoutTime(preInvoicesFilterData.updateMaxDate);
            this.refDoc = preInvoicesFilterData.refDoc || null;
            this.pageCriteria = {
                pageSize: preInvoicesFilterData.pageSize || KISS_INVOICE.pagination.defaultPageSize,
                page: preInvoicesFilterData.page || KISS_INVOICE.pagination.defaultPage,
                sorts: _setSort(preInvoicesFilterData.sorts)
            };
        }

        function _setSort(sorts) {
            if (!sorts || sorts.length === 0) {
                return KISS_INVOICE.pagination.defaultSort;
            }
            return sorts;
        }

        /**
         *
         */
        function preparBeforeSearch() {
            var clone = new PreInvoicesFilter(this);
            clone.pageCriteria = this.pageCriteria;
            if (clone.transmissionMode === 'all') {
                clone.transmissionMode = null;
            }
            if (clone.functionalStatus === 'all') {
                clone.functionalStatus = null;
            }
            clone.sellerId = this.seller ? this.seller.id : null;
            clone.buyerId = this.buyer ? this.buyer.id : null;
            return clone;
        }

        /**
         * Indiquer la page
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Mise à jour du tri (tri sur une seule colonne)
         */
        function setSort(sorts) {
            this.pageCriteria.sorts = sorts;
        }

        /**
         * Lorsqu'on ne souhaite aucun tri
         */
        function resetSort() {
            this.pageCriteria.sorts = [];
        }

        function _extractDateWithoutTime(fulldate) {
            return fulldate ? moment(fulldate).format('YYYY-MM-DD') : null;
        }
    }
})();
